// extracted by mini-css-extract-plugin
export default {"accountBreadcrumbs":"pn-z","hideOnMobile":"qn-z"};